import { useEffect, useRef } from 'react';
import { logoutService } from '@/utils/logoutService';

export const useAutoLogout = () => {
  const timeoutRef = useRef<NodeJS.Timeout>();
  
  const startLogoutTimer = () => {
    clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => {
      logoutService.autoLogout();
    }, 60 * 60 * 1000); // 2 minutes
  };

  const resetTimer = () => {
    startLogoutTimer();
  };

  useEffect(() => {
    // Start timer on mount
    startLogoutTimer();

    // Reset timer on user activity
    const events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart'];
    events.forEach(event => {
      document.addEventListener(event, resetTimer, true);
    });

    return () => {
      clearTimeout(timeoutRef.current);
      events.forEach(event => {
        document.removeEventListener(event, resetTimer, true);
      });
    };
  }, []);

  return { resetTimer };
};